<template>
  <div class="otto-notifications">
    <div class="arrow-up"></div>
    <div class="otto-notifications__content">
      <p class="otto-notifications__title">NOTIFICATIONS</p>
      <div class="otto-notifications__list">
        <Notification :notification="notification" :key="notification._id" v-for="notification in notifications" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Notification from '@/components/Notification';
import PopupMixin from '@/mixins/popup';

export default {
  name: 'notifications',
  mixins: [PopupMixin],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      notifications: state => state.notifications.list,
      showNotifications: state => state.ui.showNotifications,
    }),
  },
  methods: {
    ...mapActions([
      'getNotifications',
      'closeNotifications',
    ]),
  },
  watch: {
    showNotifications(newValue) {
      if (newValue === true) {
        this.setupListener(this.closeNotifications);
        this.getNotifications();
      } else {
        this.removeListener();
      }
    },
  },
  components: {
    Notification,
  },
};
</script>
<style lang="sass" src="@/assets/styles/notifications.sass"></style>




// WEBPACK FOOTER //
// src/components/Notifications.vue